import { useCallback, useEffect, useRef } from "react";

export const useInactivityTracker = (
  callback,
  timeout = Number(process.env.REACT_APP_USER_INACTIVITY_TIME)
) => {
  const timerRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      callback();
    }, timeout);
  }, [callback, timeout]);

  useEffect(() => {
    const id = process.env.NODE_ENV === "development" ? "root" : "curatu-root";
    const chatbotRoot = document.getElementById(id);

    if (!chatbotRoot) return;

    chatbotRoot.addEventListener("mousemove", resetTimer);
    chatbotRoot.addEventListener("keydown", resetTimer);
    chatbotRoot.addEventListener("click", resetTimer);

    resetTimer();

    return () => {
      chatbotRoot.removeEventListener("mousemove", resetTimer);
      chatbotRoot.removeEventListener("keydown", resetTimer);
      chatbotRoot.removeEventListener("click", resetTimer);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);

  return { resetTimer };
};
